import { Injectable } from '@angular/core';
import { ApiHttpClient, ListOption, ListOptionRequest } from '../modules/tcm-core.module';
import { AreaClinicViewModel, ClinicInAreaRequest } from '../models/areas';

@Injectable({
  providedIn: 'root'
})
export class AreaDataService {

  constructor(private readonly httpClient: ApiHttpClient) {
  }

  public getAreaOptionsAsync(query: string, cancellationToken: Promise<any>): Promise<ListOption<number>[]> {
    const request: ListOptionRequest = { searchString: query };
    return this.httpClient.getJsonAsync<ListOption<number>[]>('areas/options', request, cancellationToken);
  }

  public checkClinicBelongToAnotherArea(clinics: AreaClinicViewModel[], id: number, cancellationToken: Promise<any>): Promise<string[]> {
    const request: ClinicInAreaRequest  = {
      clinics: clinics,
      id: id
    };
    return this.httpClient.postJsonAsync<string[]>('areas/checkClinicBelongToAnotherArea', request, cancellationToken);
  }
  
}
